import React, {useState, useCallback} from 'react';

import {observer} from 'mobx-react';

import {useStores} from '../../../Hooks';
import procedureUtility from '../../../Utilities/ProcedureUtility';
import SettingsModalShell from '../SettingsShared/SettingsModalShell';
import useProcedureSettings from './useProcedureSettings';
import SettingsTabBody from './SettingsTabBody';
import {openDeleteProcedureConfirm} from '../DeleteProcedureModal';

const ITEM_TAB = {key: 'itemSettings', label: 'Item Settings', subtitle: 'Configure item properties and access'};
const ADVANCED_TAB = {key: 'advanced', label: 'Advanced Settings', subtitle: 'Player attributes and visibility settings'};
const MIRRORED_TAB = {key: 'mirrored', label: 'Item Settings', subtitle: 'Configure privacy and role visibility'};

const ProcedureSettingsModal = observer(() => {
    const {modalStore, generalStore, projectStore, procedureStore} = useStores();
    const [activeTab, setActiveTab] = useState(0);
    const settings = useProcedureSettings();
    const isMedia = !!settings.procedure?.MediaProcedureFile;
    const isFldt = procedureUtility.isFldt(settings.procedure);
    const isMirrored = !!settings.procedure?.importedFromWorkspace;
    const isRoleVisibilityEnabled = !!generalStore.domainSettings?.IsRoleVisibilityEnabled;
    const hasAdvancedTab = (!isMedia && !isFldt) || isRoleVisibilityEnabled;
    const tabs = isMirrored ? [MIRRORED_TAB] : (hasAdvancedTab ? [ITEM_TAB, ADVANCED_TAB] : [ITEM_TAB]);

    const handleEnter = useCallback(() => {
        const proc = modalStore.modalData?.procedure || procedureStore.currentProcedure;
        if (!proc) return;
        settings.initFromProcedure({...proc, AIInstructions: proc.AIInstructions ?? ''}, true);
        setActiveTab(0);
    }, [modalStore.modalData?.procedure, procedureStore.currentProcedure]);

    const closeModal = useCallback(() => {
        modalStore.isProcedureSettingsModalOpen = false;
        modalStore.resetModalData();
    }, [modalStore]);

    const handleDelete = () => {
        const proc = modalStore.modalData?.procedure;
        if (!proc) return;
        closeModal();
        openDeleteProcedureConfirm(proc, null);
    };

    return (
        <SettingsModalShell
            openControl="isProcedureSettingsModalOpen"
            title="Item Settings"
            subtitle={tabs[activeTab].subtitle}
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            onEnter={handleEnter}
            isDirty={settings.isDirty}
            onSave={settings.save}
            onDiscard={settings.discard}
            onDelete={isMirrored ? null : handleDelete}
            closeModal={closeModal}
        >
            <SettingsTabBody activeTab={activeTab} settings={settings} />
        </SettingsModalShell>
    );
});

export default ProcedureSettingsModal;
